module.exports = __webpack_public_path__ + "static/media/team_3.9f1d07e5.jpg";